import styles from '../styles/app.module.css';

interface PageHeaderProps {
  eyebrow: string;
  title: string;
  subtitle: string;
  /** Buttons of the area, on the right as in the click demo. */
  actions?: React.ReactNode;
}

export function PageHeader({ eyebrow, title, subtitle, actions }: PageHeaderProps): React.JSX.Element {
  return (
    <header className={styles.header}>
      <div className={styles.headerText}>
        <span className={styles.eyebrow}>{eyebrow}</span>
        <h1 className={styles.title}>{title}</h1>
        <p className={styles.subtitle}>{subtitle}</p>
      </div>
      {actions !== undefined && <div className={styles.headerActions}>{actions}</div>}
    </header>
  );
}
